<template>
  <v-tooltip top>
    <v-btn :disabled="disabled" icon slot="activator" @click="modules()">
      <v-icon color="blue-grey darken-1">folder_open</v-icon>
    </v-btn>
    <span>Module</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    modules() {
      this.$emit("module");
    }
  }
};
</script>

<style>
</style>
